import AttributionModal from './AttributionModal'
export default AttributionModal
